import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { Tab } from './luci-tabs.model';

@Component({
  selector: 'luci-tabs',
  templateUrl: './luci-tabs.component.html',
  styleUrls: ['./luci-tabs.component.scss']
})
export class LuciTabsComponent implements OnInit, OnChanges {

  @Input() tabs: Tab[] = [];
  @Input() background = '';
  @Input() count = false;
  @Input() status = false;
  @Input() emitSelectionEvent = false;

  @Output() updateTab = new EventEmitter();

  selectedTab: any = {};
  showTooltip = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tabs) {
      this.updateTabs();
    }
  }
  updateTabs() {
    this.tabs.forEach((t: Tab) => {
      if (t.active) {
        this.selectedTab = {
          name: t.name
        };
        const activeChild: Tab[] = t.children.filter((c) => c.active);
        if (activeChild.length > 0) {
          this.selectedTab.child = { name: activeChild[0].name };
        }
      }
    });
    if (this.tabs.length > 0) {
      this.updateTab.emit(this.selectedTab);
    }
  }

  goToPage(event, tab: Tab, isChild: boolean = false) {
    if (!this.emitSelectionEvent) {
      if ((isChild && this.selectedTab.child.name === tab.name) || (!isChild && this.selectedTab.name === tab.name)) {
        return;
      }
      if (isChild) {
        this.selectedTab.child = {
          name: tab.name
        };
      } else {
        this.selectedTab = {
          name: tab.name,
          child: {}
        };
      }
      this.tabs.forEach((t: Tab) => {
        if (!isChild) {
          t.active = false;
        }
        t.children.forEach((c: Tab, index) => {
          c.active = !isChild && index === 0;
        });
      });
      tab.active = true;
      this.updateTab.emit(this.selectedTab);
    } else {
      this.tabs.forEach((t: Tab) => {
        if (!isChild) {
          t.active = false;
        }
      });
      this.updateTab.emit({ select: true, tab });
      tab.active = true;
    }
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }

  getCounts(tab) {
    switch (tab.name) {
      case 'Alerts':
        return false;
      default:
        return true;
    }
  }

}
